import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-bdad7a00"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "empty-section"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_FilterSectionTitle = _resolveComponent("FilterSectionTitle");
  const _component_WrapWithSection = _resolveComponent("WrapWithSection");
  return _openBlock(), _createBlock(_component_WrapWithSection, {
    id: "list-section",
    heightFromTop: $props.heightFromTop
  }, {
    title: _withCtx(() => [_createVNode(_component_FilterSectionTitle, {
      title: $props.title,
      count: 0,
      searching: $props.searching
    }, null, 8, ["title", "searching"])]),
    body: _withCtx(() => [_createElementVNode("span", _hoisted_1, [_createTextVNode(" No " + _toDisplayString($props.title) + " match: ", 1), _createElementVNode("span", null, "\"" + _toDisplayString($options.formattedKeyword) + "\"", 1)])]),
    _: 1
  }, 8, ["heightFromTop"]);
}